import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

export const RegularPriceLine = ({ preview, options }: ComponentLineProps) => (
  <DefaultFullPreview.PreviewEntry
    label={t([
      "settings.paywall_prices.subscription.regular_price",
      preview.paywall_price.interval_type,
    ])}
    value={preview?.future_payments?.formatted_subtotal}
    dataTestId="checkout-form-preview-future-payments-regular-price"
    {...options}
  />
);
